import { useTenant } from '@/contexts/TenantContext';
import { useThemeStore } from '@core/theme/useThemeStore';

interface AuthHeaderProps {
  title: string;
  subtitle?: string;
}

export const AuthHeader = ({ title, subtitle }: AuthHeaderProps) => {
  const { tenantId, logoUrl, tenantInfo } = useTenant();
  const { theme } = useThemeStore();

  return (
    <div className="mb-8">
      {tenantId && theme && theme?.logoUrl ? (
        <div className="mb-4 flex justify-center">
          <img
            src={logoUrl || theme.logoUrl}
            alt="Company Logo"
            className="h-16 w-auto object-contain"
          />
        </div>
      ) : (
        <h1 className="mb-2 text-center text-2xl font-bold text-gray-900">
          {tenantInfo?.tenantName || 'Insta Agency'}
        </h1>
      )}
      <h2 className="text-center text-xl text-gray-600">{title}</h2>
      {subtitle && (
        <p className="mt-2 text-center text-sm text-gray-500">{subtitle}</p>
      )}
    </div>
  );
};
